import {useEffect, useRef, useState} from 'react';
import {mergeAll} from 'rxjs/operators';
import useDevices from 'src/hooks/use-devices';
import useSocket from 'src/hooks/use-socket';

export const syncDevicePosition = (map, device, animateToPosition) => {
  if (!map.getDeviceFeatureByDeviceId(device.id) && map.consumePendingReappearance(device.id)) {
    map.addFeatureDevice(device);
  }
  map.updateDevicePosition(device, animateToPosition);
};

const useMapPosition = (state, dispatch, instance) => {
  const {instance: map, deviceMap} = state;

  const [follow, setFollow] = useState(false);
  const followRef = useRef(follow);

  const {positions: positionsObservable} = useSocket();
  const {devices: deviceStore} = useDevices();

  useEffect(() => {
    followRef.current = follow;
  }, [follow]);

  useEffect(() => {
    let positionsSubscription$;

    if (map && deviceMap) {
      positionsSubscription$ = positionsObservable.pipe(
        mergeAll(),
      ).subscribe((position) => {
        try {
          const incomingDeviceId = +position.deviceId;
          const isDeviceSelected = deviceStore.selectedDevice && deviceStore.selectedDevice.id === incomingDeviceId;
          const animateToPosition = isDeviceSelected && followRef.current;
          const device = deviceMap.get(incomingDeviceId);
          if (device) {
            syncDevicePosition(map, device, animateToPosition);
          }
        } catch (error) {
          console.error('Error updating device position:', error);
        }
      });
    }

    return () => {
      if (positionsSubscription$) {
        positionsSubscription$.unsubscribe();
      }
    };
  }, [map, deviceMap, deviceStore.selectedDevice]);

  return {
    follow,
    setFollow,
  };
};

export default useMapPosition;
